import { AVATARS, SHEET_FRAME_H, SHEET_FRAME_W } from "@agency/shared";
import mapUrl from "@agency/shared/assets/maps/office.tmj?url";
import Phaser from "phaser";
import { registerAnimations } from "../anims.js";

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super("Preload");
  }

  preload(): void {
    this.load.image("tiles", "assets/tiles/office.png");
    for (const avatar of AVATARS) {
      this.load.spritesheet(avatar.id, `assets/${avatar.sheet}`, {
        frameWidth: SHEET_FRAME_W,
        frameHeight: SHEET_FRAME_H,
      });
    }
    this.load.json("officeRaw", mapUrl);
    this.load.tilemapTiledJSON("office", mapUrl);
  }

  create(): void {
    registerAnimations(this);
    this.scene.start("Office");
  }
}
